import { useContext } from 'react';
import { AdminTokenUsageContext } from '@features/admin-token-usage/contexts/AdminTokenUsageContext';
import { AdminTokenUsageContextValues } from '@features/admin-token-usage/types';

const useAdminTokenUsageFilters = (): AdminTokenUsageContextValues => {
  const context = useContext(AdminTokenUsageContext);

  if (!context)
    throw new Error(
      'useAdminTokenUsageFilters must be used within a AdminTokenUsageProvider'
    );

  return context;
};

export default useAdminTokenUsageFilters;
